class ProductSizeGuide extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.dialog = this.querySelector('dialog');
    this.openButton = this.querySelector('[data-size-guide-open]');
    this.closeButton = this.querySelector('[data-size-guide-close]');
    this.form = this.querySelector('[data-size-recommender]');
    this.result = this.querySelector('[data-size-result]');

    this.openButton?.addEventListener('click', () => this.dialog?.showModal());
    this.closeButton?.addEventListener('click', () => this.dialog?.close());
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.form?.addEventListener('submit', (event) => this.recommend(event));
    this.querySelectorAll('[data-unit-toggle]').forEach((button) => {
      button.addEventListener('click', () => this.setUnit(button.dataset.unitToggle));
    });
  }

  setUnit(unit) {
    if (!unit) return;

    this.querySelectorAll('[data-unit-toggle]').forEach((button) => {
      const isActive = button.dataset.unitToggle === unit;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    this.querySelectorAll('[data-measurement]').forEach((cell) => {
      const value = Number(cell.dataset.measurement);
      const sourceUnit = cell.dataset.sourceUnit;
      if (!Number.isFinite(value) || !sourceUnit) return;

      const converted = unit === sourceUnit ? value : sourceUnit === 'in' ? value * 2.54 : value / 2.54;
      const precisionKey = unit === 'in' ? 'precisionIn' : 'precisionCm';
      const precision = Number(cell.dataset[precisionKey] || 1);
      cell.textContent = `${converted.toFixed(precision)} ${unit === 'in' ? 'in' : 'cm'}`;
    });
  }

  recommend(event) {
    event.preventDefault();
    if (!this.form || !this.result) return;

    const formData = new FormData(this.form);
    const usualSize = String(formData.get('usual-size') || '');
    const fit = String(formData.get('fit') || 'true');
    const sizes = (this.dataset.sizes || '').split(',').filter(Boolean);
    let index = sizes.indexOf(usualSize);
    if (index < 0) index = Math.max(0, Math.min(sizes.length - 1, 1));
    if (fit === 'closer') index -= 1;
    if (fit === 'relaxed') index += 1;
    index = Math.max(0, Math.min(sizes.length - 1, index));

    const size = sizes[index];
    const fitNote = this.dataset.fitNote || 'Choose your usual size for the intended fit.';
    const target = this.findVariantControl(size);
    const soldOut = target instanceof HTMLInputElement && target.getAttribute('aria-disabled') === 'true';

    this.result.hidden = false;
    this.result.innerHTML = `
      <p class="size-guide__result-eyebrow">Your recommended size</p>
      <p class="size-guide__result-size">${this.escapeHtml(size)}</p>
      <p class="size-guide__result-note">${this.escapeHtml(fitNote)}</p>
      ${target && !soldOut ? `<button type="button" class="button size-guide__select-size" data-select-size>Select size ${this.escapeHtml(size)}</button>` : ''}
      ${soldOut ? '<p class="size-guide__stock-note">This size is currently unavailable in the selected options.</p>' : ''}
    `;

    this.result.querySelector('[data-select-size]')?.addEventListener('click', () => {
      this.selectVariantControl(target);
      this.dialog?.close();
      this.openButton?.focus();
    });
  }

  findVariantControl(size) {
    const scope = this.closest('.shopify-section') || document;
    const normalizedSize = this.normalizeSize(size);
    const controls = scope.querySelectorAll('variant-picker input[type="radio"], variant-picker option');
    return Array.from(controls).find((control) => this.normalizeSize(control.value) === normalizedSize) || null;
  }

  selectVariantControl(control) {
    if (control instanceof HTMLInputElement) {
      control.click();
      return;
    }

    if (control instanceof HTMLOptionElement && control.parentElement instanceof HTMLSelectElement) {
      control.parentElement.value = control.value;
      control.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  normalizeSize(value) {
    return String(value).toUpperCase().replaceAll(' ', '').replace('XXXL', '3XL').replace('XXL', '2XL');
  }

  escapeHtml(value) {
    const element = document.createElement('span');
    element.textContent = String(value);
    return element.innerHTML;
  }
}

if (!customElements.get('product-size-guide')) {
  customElements.define('product-size-guide', ProductSizeGuide);
}
